/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseLangDetailViewModel } from "../types/CourseLangDetailViewModel.ts";

export const courseLangDetailViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do registro de idioma do curso."),
  ),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  courseCode: z.string().describe("Código do curso.").nullish(),
  cultureInfo: z
    .string()
    .describe("Cultura do registro. Imutável após a criação.")
    .nullish(),
  cultureName: z
    .string()
    .describe(
      "Nome do idioma no idioma padrão do sistema. Vazio quando a cultura não é uma das principais do LMS.",
    )
    .nullish(),
  nameOfficial: z
    .string()
    .describe("Nome oficial do curso neste idioma.")
    .nullish(),
  nameCommercial: z
    .string()
    .describe("Nome comercial do curso neste idioma.")
    .nullish(),
  description: z
    .string()
    .describe("Descrição do curso neste idioma. Opcional.")
    .nullish(),
  contentHtml: z
    .string()
    .describe("Regimento do curso em HTML. Opcional.")
    .nullish(),
  contentInstruction: z
    .string()
    .describe("Instruções exibidas ao aluno na matrícula. Opcional.")
    .nullish(),
  contractBody: z
    .string()
    .describe(
      "Corpo do contrato de matrícula, com os marcadores de substituição do legado no padrão {Entidade.Propriedade}. Opcional.",
    )
    .nullish(),
  syllabus: z.string().describe("Ementa do curso em HTML. Opcional.").nullish(),
  detailUrl: z
    .string()
    .describe("URL de detalhe do curso usada no catálogo. Opcional.")
    .nullish(),
  internationalPlanDescription: z
    .string()
    .describe(
      "Descrição do plano internacional, sempre em texto puro. Obrigatória quando o curso é internacional. Opcional nos demais casos.",
    )
    .nullish(),
  senderApprovalRejectionDocEmail: z
    .string()
    .describe(
      "E-mail usado como remetente de resposta nos avisos de aprovação e rejeição de documentos. Opcional.",
    )
    .nullish(),
  senderApprovalRejectionDocName: z
    .string()
    .describe(
      "Nome de exibição do remetente dos avisos de documentos. Opcional.",
    )
    .nullish(),
  approvalDocMailBody: z
    .string()
    .describe(
      "Corpo do e-mail de aprovação e rejeição de documentos pessoais neste idioma. Quando vazio, o sistema usa o template genérico. Opcional.",
    )
    .nullish(),
  apoloActivationMailBody: z
    .string()
    .describe(
      "Corpo do e-mail de ativação Apolo. Campo sem consumidor identificado no legado nem no projeto novo, mantido por decisão do time. Opcional.",
    )
    .nullish(),
  contentHtmlOld: z
    .string()
    .describe(
      "Conteúdo antigo do regimento. Coluna sem consumidor no legado nem no projeto novo, mantida por decisão do time e não editável por esta API. Opcional.",
    )
    .nullish(),
  manualUrl: z
    .string()
    .describe(
      "URL assinada para download do PDF do manual. Nula quando não há arquivo.",
    )
    .nullish(),
  regimentUrl: z
    .string()
    .describe(
      "URL assinada para download do PDF do regimento. Nula quando não há arquivo.",
    )
    .nullish(),
  uspDocumentUrl: z
    .string()
    .describe(
      "URL assinada para download do PDF da carteirinha USP. Nula quando não há arquivo.",
    )
    .nullish(),
  isInternationalPlanDescriptionRequired: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a descrição do plano internacional é obrigatória, refletindo o campo InternationalCourse do curso. Regra que no legado só existia no service e não aparecia na tela.",
      ),
  ),
  allowCultureChange: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a cultura pode ser alterada. Sempre falso: o idioma é definido na criação e para trocá-lo é preciso remover o registro e criar outro.",
      ),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseLangDetailViewModel>;
